import { SuccessOk } from 'configs/statusCode'
import React, { useState, useEffect } from 'react'
import { toast } from 'react-toastify'
import { Badge } from 'reactstrap'
import '../styles.scss'


const CardItem = ({ index, itemData, Service, setShouldGetData }) => {
    const saleStatus = itemData.sale_status
    const [item, setItem] = useState({...itemData})
    const [itemStatus, setItemStatus] = useState(false)
    const [status, setStatus] = useState(false)
    const service = new Service

    useEffect(() => {
        setItemStatus(saleStatus)
    }, [saleStatus])

    useEffect(() => {
        setStatus(item.status)
    }, [item.status])

    const changeStatus = (e) => {
        const value = e.target.checked
        service.toggleSaleStatus(item.id).then((res) => {
            if (res && res.status === SuccessOk) {
                toast.success("Sale Status Changed Successfully")
                setItemStatus(value)
                // toast.success(res.data.success)
                setShouldGetData(true)
            }
        })
    }

    return (
        <>
            <tr key={index}>
                <td className='font-size-13'>{item.id}</td>
                <td className='font-size-13' style={{fontWeight: 700 }}>{item.name.en}</td>
                <td className="font-size-13">{item.unit_type_name || '-'} </td>
                <td className='font-size-13'>{toCurrency(item.price)}</td>
                <td className='font-size-13'>{item.size}</td>
                <td className='font-size-13'>{item.bedrooms || '-'}</td>
                <td className='font-size-13 btn-hover'>
                    <Badge
                        onClick={changeStatus}
                        className="font-size-14 p-2"
                        style={{background: itemStatus === 'Bought'? '#50a5f1' : '#e1e9f0', color: itemStatus ==="Bought" ? '#fff' : '#0583f2'}}
                    >{itemStatus}
                    </Badge>
                </td>

                <td className='font-size-14 py-0'>
                    <form>
                        <div className='form-check form-switch form-switch-md mb-1'>
                            <input
                                name='status'
                                checked={status}
                                type='checkbox'
                                className='form-check-input'
                                id='has_status'
                                readOnly={true}
                            />
                        </div>
                    </form>
                </td>
            </tr>
        </>

    )
}
const toCurrency = (number) => {
    const formatter = new Intl.NumberFormat("en-US");
    return formatter.format(number);
}


export default CardItem